import { showMessage } from "components/Modal";
import {
  ADD_CARD_FAILURE,
  ADD_CARD_STARTED,
  ADD_CARD_SUCCESS,
  CREATE_CREDIT_CARD_FAILURE,
  CREATE_CREDIT_CARD_STARTED,
  CREATE_CREDIT_CARD_SUCCESS,
  CREATE_PHYSICAL_CARD_FAILURE,
  CREATE_PHYSICAL_CARD_STARTED,
  CREATE_PHYSICAL_CARD_SUCCESS,
  GET_CARD_BALANCES_FAILURE,
  GET_CARD_BALANCES_STARTED,
  GET_CARD_BALANCES_SUCCESS,
  GET_PHYSICAL_CARDS_LIST_FAILURE,
  GET_PHYSICAL_CARDS_LIST_STARTED,
  GET_PHYSICAL_CARDS_LIST_SUCCESS,
  GET_VIRTUAL_CARDS_LIST_FAILURE,
  GET_VIRTUAL_CARDS_LIST_STARTED,
  GET_VIRTUAL_CARDS_LIST_SUCCESS,
  SEND_EMAIL_FAILURE,
  SEND_EMAIL_STARTED,
  SEND_EMAIL_SUCCESS,
  TOP_UP_CARD_FAILURE,
  TOP_UP_CARD_STARTED,
  TOP_UP_CARD_SUCCESS,
  UPDATE_TOP_UP_CARD_STATUS_FAILURE,
  UPDATE_TOP_UP_CARD_STATUS_STARTED,
  UPDATE_TOP_UP_CARD_STATUS_SUCCESS,
} from "redux/ActionTypes";
import {
  addCardApi,
  createCreditCardApi,
  createPhysicalCardApi,
  getCardBalancesAPI,
  getCardsLimitsAPI,
  getCardsStatusAPI,
  getPhysicalCardsListAPI,
  getVirtualCardsListAPI,
  sendEmail,
  sendEmailApi,
  setCardsLimitsAPI,
  topupCardApi,
  updateCardsStatusAPI,
  updateTopupCardStatusApi,
} from "services/API/card";
// --------------------------------------------------------------------------------
export const getPhysicalCardsListRequestAction = ({
  limit,
  offset,
  from,
  to,
  agent,
}) => {
  return async (dispatch) => {
    dispatch(getPhysicalCardsListStartedAction());
    try {
      let response = await getPhysicalCardsListAPI({
        limit,
        offset,
        from,
        to,
        agent,
      });
      if (!response.error) {
        dispatch(
          getPhysicalCardsListSuccessAction({ physicalCards: response.data })
        );
      } else {
        dispatch(
          getPhysicalCardsListFailureAction(response.data.error_message)
        );
      }
    } catch (error) {
      dispatch(getPhysicalCardsListFailureAction(error.error_message));
    }
  };
};

export const getPhysicalCardsListStartedAction = () => ({
  type: GET_PHYSICAL_CARDS_LIST_STARTED,
});

export const getPhysicalCardsListSuccessAction = (payload) => ({
  type: GET_PHYSICAL_CARDS_LIST_SUCCESS,
  payload,
});

export const getPhysicalCardsListFailureAction = (message) => ({
  type: GET_PHYSICAL_CARDS_LIST_FAILURE,
  payload: message,
});
// --------------------------------------------------------------------------------
export const getVirtualCardsListRequestAction = ({
  limit,
  offset,
  from,
  to,
  agent,
}) => {
  return async (dispatch) => {
    dispatch(getVirtualCardsListStartedAction());
    try {
      let response = await getVirtualCardsListAPI({
        limit,
        offset,
        from,
        to,
        agent,
      });
      if (!response.error) {
        dispatch(
          getVirtualCardsListSuccessAction({ virtualCards: response.data })
        );
      } else {
        dispatch(getVirtualCardsListFailureAction(response.data.error_message));
      }
    } catch (error) {
      dispatch(getVirtualCardsListFailureAction(error.error_message));
    }
  };
};
// --------------------------------------------------------------------------------
export const getCardsLimitsRequestAction = (cardId, setData) => {
  return async (dispatch) => {
    try {
      let response = await getCardsLimitsAPI(cardId);
      if (!response.error) {
        setData(response.data);
      }
    } catch (error) {}
  };
};
// --------------------------------------------------------------------------------
export const setCardsLimitsRequestAction = (data, setLoading) => {
  return async (dispatch) => {
    setLoading(true);
    try {
      let response = await setCardsLimitsAPI(data);
      if (!response.error) {
        showMessage({
          status: "success",
        });
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      showMessage({
        description: error.error_message,
        status: "error",
      });
    }
  };
};
// --------------------------------------------------------------------------------
export const updateCardsStatusRequestAction = ({
  data,
  onSuccess,
  setLoading,
}) => {
  return async (dispatch) => {
    setLoading(true);
    try {
      let response = await updateCardsStatusAPI(data);
      if (!response.error) {
        onSuccess();
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      showMessage({
        description: error.error_message,
        status: "error",
      });
    }
  };
};
// --------------------------------------------------------------------------------
export const getCardsStatusRequestAction = (cardId, setData) => {
  return async (dispatch) => {
    try {
      let response = await getCardsStatusAPI(cardId);
      if (!response.error) {
        setData(response.data);
      }
    } catch (error) {
      showMessage({
        description: error.error_message,
        status: "error",
      });
    }
  };
};

export const getVirtualCardsListStartedAction = () => ({
  type: GET_VIRTUAL_CARDS_LIST_STARTED,
});

export const getVirtualCardsListSuccessAction = (payload) => ({
  type: GET_VIRTUAL_CARDS_LIST_SUCCESS,
  payload,
});

export const getVirtualCardsListFailureAction = (message) => ({
  type: GET_VIRTUAL_CARDS_LIST_FAILURE,
  payload: message,
});
// --------------------------------------------------------------------------------
export const createCreditCardAction = ({
  currency,
  amount,
  email,
  english_first_name,
  persian_first_name,
  english_last_name,
  persian_last_name,
  setLoading,
  onSuccess,
}) => {
  return async (dispatch) => {
    dispatch(CreateCreditCardStartedAction());
    setLoading(true);
    try {
      let response = await createCreditCardApi({
        currency,
        amount: `${Number(amount).toFixed(2)}`,
        email,
        english_first_name,
        persian_first_name,
        english_last_name,
        persian_last_name,
      });
      if (!response.error) {
        setLoading(false);
        dispatch(CreateCreditCardSuccessAction());
        onSuccess();
      } else {
        setLoading(false);
        dispatch(CreateCreditCardFailureAction(response.data.error_message));
      }
    } catch (error) {
      setLoading(false);
      showMessage({
        description: error.error_message,
        status: "error",
      });
      dispatch(CreateCreditCardFailureAction(error.error_message));
    }
  };
};

export const CreateCreditCardStartedAction = () => ({
  type: CREATE_CREDIT_CARD_STARTED,
});

export const CreateCreditCardSuccessAction = (payload) => ({
  type: CREATE_CREDIT_CARD_SUCCESS,
  payload,
});

export const CreateCreditCardFailureAction = (message) => ({
  type: CREATE_CREDIT_CARD_FAILURE,
  payload: message,
});
// --------------------------------------------------------------------------------
export const createPhysicalCardAction = ({
  currency,
  agent,
  amount,
  email,
  english_first_name,
  persian_first_name,
  english_last_name,
  persian_last_name,
  card_number,
  cvv2,
  expire_date,
  setLoading,
  onSuccess,
}) => {
  return async (dispatch) => {
    dispatch(CreatePhysicalCardStartedAction());
    setLoading(true);
    try {
      let response = await createPhysicalCardApi({
        currency,
        agent,
        amount: `${Number(amount).toFixed(2)}`,
        email,
        english_first_name,
        persian_first_name,
        english_last_name,
        persian_last_name,
        card_number,
        cvv2,
        expire_date,
      });
      if (!response.error) {
        setLoading(false);
        dispatch(CreatePhysicalCardSuccessAction());
        onSuccess();
      } else {
        setLoading(false);
        dispatch(CreateCreditCardFailureAction(response.data.error_message));
      }
    } catch (error) {
      setLoading(false);
      showMessage({
        description: error.error_message,
        status: "error",
      });
      dispatch(CreatePhysicalCardFailureAction(error.error_message));
    }
  };
};

export const CreatePhysicalCardStartedAction = () => ({
  type: CREATE_PHYSICAL_CARD_STARTED,
});

export const CreatePhysicalCardSuccessAction = (payload) => ({
  type: CREATE_PHYSICAL_CARD_SUCCESS,
  payload,
});

export const CreatePhysicalCardFailureAction = (message) => ({
  type: CREATE_PHYSICAL_CARD_FAILURE,
  payload: message,
});
// --------------------------------------------------------------------------------
export const topupCardRequestAction = ({
  email,
  currencyId,
  amount,
  onSuccess,
}) => {
  return async (dispatch) => {
    dispatch(topupCardStartedAction());
    try {
      let response = await topupCardApi({
        email,
        currencyId,
        amount,
      });
      if (response.status === "success") {
        dispatch(topupCardSuccessAction());
        onSuccess();
      } else {
        dispatch(topupCardFailureAction(response.data.error_message));
      }
    } catch (error) {
      dispatch(topupCardFailureAction(error.error_message));
      showMessage({
        description: error.error_message,
        status: "error",
      });
    }
  };
};

export const topupCardStartedAction = () => ({
  type: TOP_UP_CARD_STARTED,
});

export const topupCardSuccessAction = (payload) => ({
  type: TOP_UP_CARD_SUCCESS,
  payload,
});

export const topupCardFailureAction = (message) => ({
  type: TOP_UP_CARD_FAILURE,
  payload: message,
});
// --------------------------------------------------------------------------------
export const sendEmailAction = ({ cardId, onSuccess, onFailure }) => {
  return async (dispatch) => {
    dispatch(SendEmailStartedAction());
    try {
      let response = await sendEmailApi({ cardId, onSuccess });
      if (!response.error) {
        dispatch(SendEmailSuccessAction(response.data));
        onSuccess();
      } else {
        dispatch(SendEmailFailureAction(response.data.error_message));
      }
    } catch (error) {
      onFailure();
      showMessage({
        description: error.error_message,
        status: "error",
      });
      dispatch(SendEmailFailureAction(error.error_message));
    }
  };
};

export const SendEmailStartedAction = () => ({
  type: SEND_EMAIL_STARTED,
});

export const SendEmailSuccessAction = (payload) => ({
  type: SEND_EMAIL_SUCCESS,
  payload,
});

export const SendEmailFailureAction = (message) => ({
  type: SEND_EMAIL_FAILURE,
  payload: message,
});
// --------------------------------------------------------------------------------
export const updateTopupCardStatusRequestAction = ({
  reference_number,
  isCharged,
  onSuccess,
}) => {
  return async (dispatch) => {
    dispatch(updateTopupCardStatusStartedAction());
    try {
      let response = await updateTopupCardStatusApi({
        reference_number,
        isCharged,
      });
      if (!response.error) {
        dispatch(updateTopupCardStatusSuccessAction());
        onSuccess();
      } else {
        dispatch(
          updateTopupCardStatusFailureAction(response.data.error_message)
        );
      }
    } catch (error) {
      showMessage({
        description: error.error_message,
        status: "error",
      });
      dispatch(updateTopupCardStatusFailureAction(error.error_message));
    }
  };
};

export const updateTopupCardStatusStartedAction = () => ({
  type: UPDATE_TOP_UP_CARD_STATUS_STARTED,
});

export const updateTopupCardStatusSuccessAction = (payload) => ({
  type: UPDATE_TOP_UP_CARD_STATUS_SUCCESS,
  payload,
});

export const updateTopupCardStatusFailureAction = (message) => ({
  type: UPDATE_TOP_UP_CARD_STATUS_FAILURE,
  payload: message,
});
// --------------------------------------------------------------------------------
export const addCardAction = ({ email, onSuccess }) => {
  return async (dispatch) => {
    dispatch(addCardStartedAction());
    try {
      let response = await addCardApi({
        email,
      });
      if (!response.error) {
        dispatch(addCardSuccessAction());
        onSuccess();
      } else {
        dispatch(addCardFailureAction(response.data.error_message));
      }
    } catch (error) {
      dispatch(addCardFailureAction(error.error_message));
      showMessage({
        description: error.error_message,
        status: "error",
      });
    }
  };
};

export const addCardStartedAction = () => ({
  type: ADD_CARD_STARTED,
});

export const addCardSuccessAction = (payload) => ({
  type: ADD_CARD_SUCCESS,
  payload,
});

export const addCardFailureAction = (message) => ({
  type: ADD_CARD_FAILURE,
  payload: message,
});
// --------------------------------------------------------------------------------
export const getCardBalancesRequestAction = ({ email, onSuccess }) => {
  return async (dispatch) => {
    dispatch(getCardBalancesStartedAction());
    try {
      let response = await getCardBalancesAPI({ email });
      if (!response.error) {
        dispatch(getCardBalancesSuccessAction());
        onSuccess(response.data);
      } else {
        dispatch(getCardBalancesFailureAction(response.data.error_message));
      }
    } catch (error) {
      dispatch(getCardBalancesFailureAction(error.error_message));
    }
  };
};

export const getCardBalancesStartedAction = () => ({
  type: GET_CARD_BALANCES_STARTED,
});

export const getCardBalancesSuccessAction = (payload) => ({
  type: GET_CARD_BALANCES_SUCCESS,
  payload,
});

export const getCardBalancesFailureAction = (message) => ({
  type: GET_CARD_BALANCES_FAILURE,
  payload: message,
});
